'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/core/styles');
var CssBaseline = require('@material-ui/core/CssBaseline');
var theme = require('./theme.js');
var colors = require('./colors.js');
var ThemeContext = require('./ThemeContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var CssBaseline__default = /*#__PURE__*/_interopDefaultLegacy(CssBaseline);

/**
 * Provides the app with a change-able MUI theme.
 */

var ThemeProvider = _ref => {
  var {
    primary: primaryFromProps = colors.colors.indigo,
    secondary: secondaryFromProps = colors.colors.teal,
    mode: modeFromProps = 'light',
    children
  } = _ref;
  var [theme$1, setTheme] = React__default['default'].useState({
    primary: primaryFromProps,
    secondary: secondaryFromProps,
    mode: modeFromProps
  });
  var muiTheme = theme.createTheme(theme$1);
  React__default['default'].useEffect(() => {
    setTheme({
      primary: primaryFromProps,
      secondary: secondaryFromProps,
      mode: modeFromProps
    });
  }, [primaryFromProps, secondaryFromProps, modeFromProps]);
  return /*#__PURE__*/React__default['default'].createElement(styles.ThemeProvider, {
    theme: theme.createTheme(theme$1)
  }, /*#__PURE__*/React__default['default'].createElement(CssBaseline__default['default'], null), /*#__PURE__*/React__default['default'].createElement(ThemeContext.ThemeContext.Provider, {
    value: {
      muiTheme,
      theme: theme$1,
      setTheme
    }
  }, children));
};
ThemeProvider.propTypes = {
  /** Wrapped content of the provider */
  children: index.node,

  /** Theme object with default mode and colors */
  primary: index.object,
  secondary: index.object,
  mode: index.oneOf(['light', 'dark'])
};

exports.ThemeProvider = ThemeProvider;
exports.default = ThemeProvider;
